






























































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Feed from "@/components/timeline/_feed.vue";
import MemberCard from "@/components/community/_memberCard.vue";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {execCommandCopy} from "@/script/util";
import Toast from "@/script/message";
import {scrollDone} from "@/script/scrollManager";
import {AxiosError} from "axios";

import Comment from "@/components/timeline/Comment.vue";
import CommentInput from "@/components/comment/_commentInput.vue";
import UserAvatar from "@/components/user/_userAvatar.vue";
import CommunityCard from "@/components/community/_communityCard.vue";
import SubscribeBtn from "@/components/community/_subscribeBtn.vue";

@Component({
    components: {
        Feed,
        MemberCard,
        Swiper,
        SwiperSlide,
        Comment,
        CommentInput,
        UserAvatar,
        CommunityCard, SubscribeBtn

    },
})
export default class SearchPage extends Vue {
    toast = new Toast();
    type: string = Object.keys(this.$route.query)[0];
    query: any = this.$route.query[Object.keys(this.$route.query)[0]];
    posts: any = [];
    games: any = [];
    memberList: any = [];
    communityList: any = [];
    keyword: string | (string | null)[] = '';

    limit: number = 5;
    offset: number = 0;
    sort: string = '';

    isAddData: boolean = false;
    comments: any = [];
    isOpenedComments: boolean = false;

    TSSswiperOption = {
        slidesPerView: 8,
        spaceBetween: 0,
        breakpoints: {
            300: {
                slidesPerView: 2.5
            },
            480: {
                slidesPerView: 3.5
            },
            768: {
                slidesPerView: 4.5
            },
            992: {
                slidesPerView: 6
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }

    async mounted() {
        if (this.$store.getters.userData.length > 0) {
            this.keyword = this.$route.query.username
            this.memberList = this.$store.getters.userData;
        }
        else {
            this.keyword = this.$route.query.q
        }

        this.memberList = this.$store.getters.researchData.users;
        this.posts = this.$store.getters.researchData.posts;
        this.communityList = this.$store.getters.researchData.community;
        // const result = await this.$api.search(this.query, this.type);
        // this.posts = result.posts;
        this.games = this.$store.getters.researchData.games;
        this.fetch()
    }

    beforeDestroy() {
        this.$store.dispatch('resetResearchData')
    }

    fetch() {
        const obj = {
            q: this.$route.query.q,
            limit: 5
        };

        this.$api.search(obj)
            .then((res: any) => {
                this.memberList = res.users;
                this.communityList = res.community;
                this.games = res.games;
                this.posts = res.posts;

            })
            .catch((err: any) => {

            })
    }


    toGamePage(gamePath: string, gameId: number) {
        this.$router.push(`/${this.$i18n.locale}/timeline/game/${gamePath}?game_id=${gameId}`)


    }

    @Watch('$route.query.q')
    watchQuery() {
        this.keyword = this.$route.query.q
        this.fetch();
    }

    userPage(channel_id: string) {
        this.$router.push(`/${this.$i18n.locale}/channel/${channel_id}/timeline`)
    }

    playGame(pathname: string) {
        window.open(
            this.$store.getters.homeUrl + `play/${pathname}`, "_blank");

    }


}
